import React from 'react';
import PropTypes from 'prop-types';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/

var classnames = createCommonjsModule(function (module) {
/* global define */
(function () {

  var hasOwn = {}.hasOwnProperty;

  function classNames() {
    var classes = [];

    for (var i = 0; i < arguments.length; i++) {
      var arg = arguments[i];
      if (!arg) continue;
      var argType = typeof arg;

      if (argType === 'string' || argType === 'number') {
        classes.push(arg);
      } else if (Array.isArray(arg) && arg.length) {
        var inner = classNames.apply(null, arg);

        if (inner) {
          classes.push(inner);
        }
      } else if (argType === 'object') {
        for (var key in arg) {
          if (hasOwn.call(arg, key) && arg[key]) {
            classes.push(key);
          }
        }
      }
    }

    return classes.join(' ');
  }

  if ( module.exports) {
    classNames.default = classNames;
    module.exports = classNames;
  } else {
    window.classNames = classNames;
  }
})();
});

var _excluded = ["ref", "className", "to", "target", "children", "isInternal"],
    _excluded2 = ["className", "to", "target", "renderLink", "children"];
var LinkTarget = {
  _self: "_self",
  _blank: "_blank",
  _parent: "_parent",
  _top: "_top"
};

var defaultRenderLink = function defaultRenderLink(_ref) {
  var ref = _ref.ref,
      className = _ref.className,
      to = _ref.to,
      target = _ref.target,
      children = _ref.children,
      isInternal = _ref.isInternal,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/React.createElement("a", _extends({
    ref: ref,
    href: to,
    target: target,
    className: classnames(className)
  }, props), children);
};

var Link = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var className = _ref2.className,
      to = _ref2.to,
      target = _ref2.target,
      renderLink = _ref2.renderLink,
      children = _ref2.children,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2);

  var isInternal = /^(\/|#)(?!\/)/.test(to);
  return renderLink(_extends({
    ref: ref,
    to: to,
    target: target,
    className: className,
    isInternal: isInternal,
    children: children
  }, props));
});
Link.propTypes = {
  className: PropTypes.string,
  to: PropTypes.string.isRequired,
  target: PropTypes.oneOf(Object.keys(LinkTarget)),
  renderLink: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};
Link.defaultProps = {
  className: undefined,
  target: LinkTarget.self,
  renderLink: defaultRenderLink
};

export default Link;
export { Link, LinkTarget };
//# sourceMappingURL=index.js.map
